import { useCallback, useEffect, useRef } from 'react';

// Idle-aware polling support. The visibilitychange pause covers hidden tabs,
// but a tab left VISIBLE on a monitor overnight kept polling at full cadence
// (2026-06-11 Zoho credit burn: ~28 calls/min sustained). After 15 min with
// no user input, pollers drop to an effective 10-min cadence; any interaction
// restores full cadence immediately.
export const IDLE_AFTER_MS = 15 * 60 * 1000;
export const IDLE_POLL_MS = 10 * 60 * 1000;

export default function useIdleAware({ onActive } = {}) {
  const lastInteraction = useRef(Date.now());
  const onActiveRef = useRef(onActive);
  onActiveRef.current = onActive;

  useEffect(() => {
    function bump() {
      const wasIdle = Date.now() - lastInteraction.current > IDLE_AFTER_MS;
      lastInteraction.current = Date.now();
      if (wasIdle && onActiveRef.current) onActiveRef.current();
    }
    window.addEventListener('pointerdown', bump, { passive: true });
    window.addEventListener('keydown', bump, { passive: true });
    window.addEventListener('wheel', bump, { passive: true });
    return () => {
      window.removeEventListener('pointerdown', bump);
      window.removeEventListener('keydown', bump);
      window.removeEventListener('wheel', bump);
    };
  }, []);

  return useCallback(() => Date.now() - lastInteraction.current > IDLE_AFTER_MS, []);
}
